import axios from 'axios';
import stringifyObject from '../../helpers/stringify-object';
import Translator from '../translator';
import xhrRoutes from '../routes/xhr';
import giveTranslation from '../give-translations';

const fn = {
  init: () => {
    const commentDeletes = document.querySelectorAll('.js-comment-delete');

    if (!commentDeletes.length) {
      return;
    }

    [].forEach.call(commentDeletes, (commentDelete) => {
      commentDelete.addEventListener('click', (e) => {
        e.preventDefault();

        const commentId = commentDelete.getAttribute('data-comment-remove-id');

        if (!commentId) {
          return;
        }

        if (!confirm(giveTranslation('api.confirm.comment.remove'))) {
          return;
        }

        const route = xhrRoutes.comment.removeComment;
        route.params.comment_id = commentId;

        axios.post(route.url, stringifyObject(route.params))
          .then((response) => {
            if (response.data.status === 'fail') {
              fn.showNotification('error', Translator.trans('api.error.fail'));
            } else {
              fn.showNotification('success', Translator.trans('api.community.comment.removed'));
            }

            document.querySelector(`[data-comment-id="${commentId}"]`).remove();
            app.msnry.inst.layout();
          })
          .catch((error) => {
            console.log(error);
          })
          .then(() => {
          });
      });
    });
  },
  showNotification: (type, message) => {
    const notification = document.createElement('div');
    notification.classList.add('notification');
    notification.classList.add(`notification--${type}`);
    notification.innerHTML = message;
    document.body.appendChild(notification);
  },
};

export default fn;
